import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@app/_core/services/app.service';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
@Component({
  selector: 'app-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.scss'],
})
export class ConsoleComponent implements OnInit {
  constructor(
    private appService: AppService,
    private router: Router,
    private mainController: MainControllerComponent
  ) {}

  currentpath: any = '';
  curPath = '';
  currentMenu: any = {};
  action = '';

  showTable: boolean = true;
  showCrud: boolean = false;
  ngOnInit() {
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      if (this.currentMenu?.listmenu != '') {
        this.currentpath = this.currentMenu.listmenu;
      }
      if (this.currentMenu.menu != '') {
        this.currentpath = this.currentpath + ' > ' + this.currentMenu.menu;
      }
      if (this.currentMenu.submenu != '') {
        this.currentpath = this.currentpath + ' > ' + this.currentMenu.submenu;
      }
      this.action = this.currentMenu.action;

      if (this.action != '') {
        this.loadActionTable(this.action);
      }
    });
      if (this.mainController.getSoftPhoneStatus() == 'Initializing...')
          this.mainController.initializeSoftPhone();
    this.appService.setUserStatus(12, null);

    if (localStorage.getItem('pageRefreshed') === 'true') {
      localStorage.removeItem('pageRefreshed');
      localStorage.removeItem('selectedQueue');
        
    }
  }

  loadActionTable(action: string) {
    this.router.navigateByUrl(action);
  }
}
